export const scrollToElement = element => document.querySelector(element).scrollIntoView({behavior:"smooth"});